import { GlobalState } from '../../reducers';

export const getAccessToken = (state: GlobalState) => state?.auth?.accessToken;
